import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { htmlToMultilineText } from '#/shared/lib/html'
import { sanitizeSmsFragment } from '#/shared/lib/sms-sanitize'
import { cn } from '#/shared/lib/utils'

/**
 * Tells the agent their message carries characters that will be simplified at
 * send (fancy Unicode font, invisible characters, smart punctuation, editor
 * formatting) — Telnyx spam-blocks those, so the send path folds them to plain
 * text. Informational only: nothing is blocked, and the compared body is the
 * character-level clean, so plain whitespace tidying never triggers it.
 */
export function SmsSanitizeNotice({
  html,
  className,
}: {
  /** The composer's editor HTML — the draft that will be flattened and sent. */
  html: string
  className?: string
}) {
  const { t } = useTranslation()
  const simplified = useMemo(() => {
    const raw = htmlToMultilineText(html)
    return sanitizeSmsFragment(raw) !== raw
  }, [html])
  if (!simplified) return null
  return (
    <p className={cn('text-xs text-warm-500', className)}>
      {t('smsSanitize.notice')}
    </p>
  )
}
